@if(loading() || isLoadingText) {
<div class="h-full w-full flex items-center justify-center bg-gray-50">
    <div class="text-gray-500">Loading...</div>
</div>
} @else {
@if (previewType === PreviewType.IMAGE) {
@if (imageScrollable()) {
<div class="h-full w-full overflow-y-auto overflow-x-hidden scrollbar-thin bg-gray-50">
    <div class="min-h-full w-full flex items-center justify-center p-4">
        <img [src]="attachment.fullUrl || attachment.url" [alt]="attachment.filename || 'Image'"
            class="max-w-full h-auto max-h-none" />
    </div>
</div>
} @else {
<div class="h-full w-full flex items-center justify-center bg-gray-50">
    <img [src]="attachment.fullUrl || attachment.url" [alt]="attachment.filename || 'Image'"
        class="max-w-full max-h-full object-contain" />
</div>
}
} @else if (previewType === PreviewType.PDF_VIEWER) {
<app-pdf-viewer class="h-full w-full" [pdfUrl]="attachment.fullUrl || attachment.url" [isResizing]="isResizing()"
    [title]="attachment.filename || 'PDF Document'" [hideToolbar]="true" [initialPage]="pageNumber()">
</app-pdf-viewer>
} @else if (previewType === PreviewType.ONLY_OFFICE) {
<app-document-preview class="h-full w-full" [documentId]="documentId()" [file]="attachment" [isResizing]="isResizing()">
</app-document-preview>
} @else if (previewType === PreviewType.HTML) {
<div class="h-full w-full flex flex-col relative">
    <!-- Toggle Tabs -->
    <div class="absolute top-2 right-2 z-10">
        <app-select-button [options]="htmlViewModeOptions" [(ngModel)]="htmlViewMode"
            (selectionChange)="setHtmlViewMode($event)" size="small">
        </app-select-button>
    </div>

    <!-- Content Area -->
    <div class="flex-1 overflow-auto" [class.p-4]="htmlViewMode !== HtmlViewMode.RENDERED">
        @if (htmlViewMode === HtmlViewMode.RENDERED) {
        <iframe #previewIframe class="w-full h-full border-0"></iframe>
        } @else {
        <pre
            class="text-sm font-mono bg-gray-50 p-4 rounded border overflow-auto h-full whitespace-pre-wrap"><code>{{textContent}}</code></pre>
        }
    </div>
</div>
} @else if (previewType === PreviewType.CODE_MIRROR) {
<div class="h-full w-full flex flex-col">
    <div #codeEditorContainer class="h-full w-full"></div>
</div>
} @else if (previewType === PreviewType.JSON) {
<div class="h-full w-full flex flex-col bg-gray-50 overflow-hidden">
    <!-- Syntax-highlighted JSON body -->
    <div class="flex-1 overflow-auto">
        <pre
            class="json-preview-pre text-sm font-mono p-5 m-0 min-h-full leading-relaxed bg-gray-50"><code [innerHTML]="jsonHighlighted"></code></pre>
    </div>
</div>
} @else if (previewType === PreviewType.MARKDOWN) {
<div class="h-full w-full flex flex-col">
    <div class="multi-preview-markdown flex-1 overflow-y-auto max-h-full w-full h-full px-6 py-4">
        <div [innerHTML]="textContent | markdownRender" dynamicComponentRenderer></div>
    </div>
</div>
} @else if (previewType === PreviewType.CANVAS) {
<div class="h-full w-full flex flex-col">
    <div #canvasContainer class="prose overflow-y-auto max-h-full w-full h-full px-6 py-4"></div>
</div>
} @else if (previewType === PreviewType.TEXT) {
<div class="h-full w-full flex flex-col">
    <pre
        class="text-sm font-mono bg-gray-50 p-4 rounded border overflow-auto h-full w-full whitespace-pre-wrap">{{textContent}}</pre>
</div>
}
}
